






import Vue from 'vue'

interface Computed {
  caption: string
  maxIndex: number
  currentIndex: number
  minShowIndex: number
  maxShowIndex: number
  isMarker: boolean
  isHidden: boolean
  isFirst: boolean
  isLast: boolean
  isFirstSection: boolean
  isLastSection: boolean
}

interface Props {
  index: number
  currentPage: number
  sliderLength: number
}

const PAGINATION_LENGTH = 4
const HALF_PAGINATION_LENGTH = Math.round((PAGINATION_LENGTH - 1) / 2)

export default Vue.component<{}, {}, Computed, Props>(
  'slider-pagination-item',
  {
    props: {
      index: {
        required: true,
      },
      currentPage: {
        required: true,
      },
      sliderLength: {
        required: true,
      },
    },
    computed: {
      maxIndex(): number {
        return this.sliderLength - 1
      },
      currentIndex(): number {
        return this.index - 1
      },
      minShowIndex(): number {
        return this.isFirstSection
          ? 0
          : this.isLastSection
          ? this.maxIndex - PAGINATION_LENGTH
          : this.currentPage - HALF_PAGINATION_LENGTH
      },
      maxShowIndex(): number {
        return this.isFirstSection
          ? PAGINATION_LENGTH
          : this.isLastSection
          ? this.maxIndex
          : this.currentPage + HALF_PAGINATION_LENGTH
      },
      isMarker(): boolean {
        return (
          this.currentIndex + 1 === this.minShowIndex ||
          this.currentIndex - 1 === this.maxShowIndex
        )
      },
      isHidden(): boolean {
        if (this.isFirst || this.isLast || this.isMarker) {
          return false
        }
        return (
          this.currentIndex < this.minShowIndex ||
          this.currentIndex > this.maxShowIndex
        )
      },
      isFirst(): boolean {
        return this.currentIndex === 0
      },
      isLast(): boolean {
        return this.currentIndex >= this.sliderLength - 1
      },
      isFirstSection(): boolean {
        return this.currentPage < PAGINATION_LENGTH
      },
      isLastSection(): boolean {
        return this.currentPage > this.maxIndex - PAGINATION_LENGTH
      },
      caption(): string {
        return this.isMarker ? '...' : `${this.index}`
      },
    },
  },
)
